<template>
  <v-layout class="drawer-container" column >
    <v-toolbar class="header-list">
      <strong class="pl-2">{{$tc(`Admin.${itemTypeName}.List.Nb${itemTypeName}`,items.length)}}</strong>
      <v-spacer/>      
      <component v-if="componentExtendName" :is="componentExtendName"  />        
      <v-btn icon :to="{name:`New${itemTypeName}`}" exact :title="$t(`Admin.${itemTypeName}.List.AddTooltip`)" ><v-icon>mdi-plus</v-icon></v-btn>
      <v-btn class="mr-4" :input-value="filterVisible" icon @click.stop.prevent="toggleFilter" :title="$t('Admin.FilterTooltip')" >
        <v-badge color="#dd0000" >
          <template v-slot:badge v-if="hasFilter"> 
            <v-menu open-on-hover >
              <span slot="activator">{{nbFiltre}}</span>
              <v-list>
                <v-list-tile>
                  <v-btn @click="resetFilter">{{$t('Admin.ResetFilterTooltip')}}<v-icon right>mdi-filter-remove</v-icon></v-btn>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <v-icon>mdi-filter</v-icon>
        </v-badge>                
      </v-btn>        
    </v-toolbar>    
    <component :is="componentFilterName" :itemTypeName="itemTypeName" v-if="filterVisible" class="filter" />
    <div ref="liste" class="liste" :style="{overflow:items.length <= 24?'auto':'none'}">      
      <auto-virtual-scroll-list 
        v-if="items.length > 24" 
        v-resize="onResize" :totalHeight="height"
        :defaultHeight="36"
        :extra-items="5"
        style="width: 100%;">            
        <component :is="componentLineName" :itemTypeName="itemTypeName" :item="item" v-for="item in items" :key="item.id" />        
      </auto-virtual-scroll-list>
      <div v-else >
        <component :is="componentLineName" :itemTypeName="itemTypeName" :item="item" v-for="item in items" :key="item.id" />                
      </div>
    </div>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import { FilterBase } from '@/models/filter/FilterBase'
import AdminListLine from '@/components/admin/AdminListLine.vue'
import AdminFilter from '@/components/admin/AdminFilter.vue'
import camelCase from 'lodash.camelcase'

@Component({
  name: 'AdminList',
  components: {AdminListLine,AdminFilter}
})

export default class AdminList<T extends AloDbBase> extends Vue {  
  filterVisible =  false
  height = 100        

  mounted(){
    this.onResize()
  }

  get componentLineName() {
    return 'AdminListLine'
  }

  get componentExtendName() {
    return null as null|string
  }

  get componentFilterName() {
    return 'AdminFilter'
  }  

  onResize(){            
    //@ts-ignore
    this.height = this.$refs.liste.clientHeight        
  }

  toggleFilter(){        
    this.filterVisible = !this.filterVisible
    this.$nextTick(()=>this.onResize())       
  }
  
  get itemTypeName() {
    return ""
  }  

  get items():Array<T> {    
    //@ts-ignore
    return this.$store.myGetters[`${camelCase(this.itemTypeName)}s`].filter(g =>  (this.filter.search.length == 0 ||  g.searchString.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1)) 
  }

  get filter():FilterBase|null {    
    //@ts-ignore
    return this.$store.myGetters[`admin${this.itemTypeName}Filter`]
  }

  get nbFiltre():number {
    return this.filter!.search.length > 0?1:0
  }

  get hasFilter() {
    return this.nbFiltre > 0
  }

  resetFilter() {
    //@ts-ignore
    this.$store.myActions[`${this.itemTypeName.toUpperCase()}_UPDATE_FILTER_ADM`](new FilterBase())
  }
  
}

</script>


<style scope>  
  .header-list{
    flex: 0 0 auto;
  }
  .filter{
    flex: 0 0 auto;    
    height: min-content;
    background-color: #eee;
  }
 .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }  
</style>